export class AuditQueryGridFilters {
  projectTypeId: number;
  projectId: number;
  measureId: number;
  numeratorId: number;
  complianceCode: string;
  enrollee: number;
  enrolleeMemberName: string;
  enrolleeFirstName: string;
  enrolleeLastName: string;
  enrolleeDateOfBirth: string;
  icdCode: string;
  vrcCode: string;
  hccCode: string;

  constructor(options: Partial<AuditQueryGridFilters> = {}) {
    this.projectTypeId = options.projectTypeId;
    this.projectId = options.projectId;
    this.measureId = options.measureId;
    this.numeratorId = options.numeratorId;
    this.complianceCode = options.complianceCode;
    this.enrollee = options.enrollee;
    this.enrolleeMemberName = options.enrolleeMemberName;
    this.enrolleeFirstName = options.enrolleeFirstName;
    this.enrolleeLastName = options.enrolleeLastName;
    this.enrolleeDateOfBirth = options.enrolleeDateOfBirth;
    this.icdCode = options.icdCode;
    this.vrcCode = options.vrcCode;
    this.hccCode = options.hccCode;
  }
}
